import Hero from "../components/Hero";
import HeroImage from "../../assets/images/ClientPortal1.jpg";
import React from "react";
import ClientPortalCard from "../components/ClientPortalCard";
import "../../css/designSystem/ClientPortalCard.css";
import { ReactComponent as CreditReportIcon } from "../../assets/icons/ClientPortal1.svg";
import { ReactComponent as AppointmentIcon } from "../../assets/icons/ClientPortal2.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/ClientPortal3.svg";
import { ReactComponent as GoogleReviewIcon } from "../../assets/icons/ClientPortal4.svg";
import { ReactComponent as NewClientIcon } from "../../assets/icons/ClientPortal5.svg";
import { ReactComponent as ExistingClientIcon } from "../../assets/icons/ClientPortal6.svg";
import { ReactComponent as MedicalQuestionnaireIcon } from "../../assets/icons/ClientPortal7.svg";
import { useNavigate } from "react-router-dom";


const ClientPortalPage = () => {
  const navigate = useNavigate();
  
  const portalCards = [
    {
      icon: CreditReportIcon,
      title: "Credit Report",
      description:
        "Get a complete view of your credit report and credit score.",
      onClick: () =>
        window.open(
          "https://www.checkmyfile.com/get-mortgage-ready?partner=2553&transaction=b87ef86051084059b2d4886aace8c903&utm_source=everflow&utm_medium=referral&utm_campaign=2553",
          "_blank",
        ),
    },
    {
      icon: AppointmentIcon,
      title: "Book Appointment",
      description:
        "Book a free 30 minute appointment with one of our advisers.",
      onClick: () => navigate("/our-team"),
    },
    {
      icon: UploadIcon,
      title: "Document Upload",
      description:
        "Your files will be uploaded securely to our Dropbox account.",
      onClick: () =>
        window.open(
          "https://www.dropbox.com/request/75Iujj0kYrciaTXUYI4k",
          "_blank",
        ),
    },
    {
      icon: GoogleReviewIcon,
      title: "Google Review",
      description: "Happy with the service? Leave us a review!",
      onClick: () =>
        window.open(
          "https://www.google.com/maps/place/WPP+Financial+Services/@51.3474047,0.5073837,17z/data=!3m1!5s0x47d8ccd304d36bf1:0x5467cb836a27890c!4m8!3m7!1s0x47d8cdef0249f371:0x2367658a8a285780!8m2!3d51.3474047!4d0.5073837!9m1!1b1!16s%2Fg%2F11gw26qwxn?entry=ttu&g_ep=EgoyMDI2MDQwNi4wIKXMDSoASAFQAw%3D%3D",
          "_blank",
        ),
    },
    {
      icon: NewClientIcon,
      title: "New Client",
      description: "Enquiry form for new clients.",
      onClick: () =>
        window.open("https://krln2v5trq0.typeform.com/to/Dt9ngh0W", "_blank"),
    },
    {
      icon: ExistingClientIcon,
      title: "Existing Client",
      description: "Enquiry form for existing clients.",
      onClick: () =>
        window.open("https://krln2v5trq0.typeform.com/to/Pg1Yf0BP", "_blank"),
    },
    {
      icon: MedicalQuestionnaireIcon,
      title: "Medical Questionnaire",
      description:
        "Health & Medical Questionnaire to recommend most suitable policies.",
      onClick: () =>
        window.open("https://krln2v5trq0.typeform.com/to/MMP9A9q7", "_blank"),
    },
    {
      icon: MedicalQuestionnaireIcon,
      title: "Consumer Duty Survey",
      description: "Customer feedback on our service",
      onClick: () =>
        window.open(
          "https://docs.google.com/forms/d/e/1FAIpQLScnYPs2U9xunKfrSrKSiAlLeXZR237DIFSKHDFsodsEw0dynQ/viewform",
          "_blank",
        ),
    },
  ];
  return (
    <div className="home-page">
      <Hero
        title="Client Portal"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content">
          <div
            className="cards-wrapper"
            style={{ padding: "2rem 0", flexWrap: "wrap" }}
          >
            {portalCards.map((card, idx) => (
              <ClientPortalCard key={idx} {...card} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientPortalPage;
